export const TeamChatReactionPickerTestIds = {
  PICKER_BUTTON: 'team-chat.reaction-picker-button',

  getEmojiButtonId: index => `reaction-picker.emoji-${index}-button`,
};
